import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import renderHTML from 'react-render-html'
import { fetchSingleNewsData } from '../../../redux/action/homePage/news/homeSingleNews'
import MainLoading from '../../../utils/MainLoading'
import HomeMainTitle from '../../homeTitle/HomeMainTitle'
import Wrapper from '../../homeWrapper/Wrapper'
import moment from "moment-jalaali";
import default_image_url from '../../../redux/api/API'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const SingleNews = (props) => {
    const single_news = useSelector(state => state.single_news)
    const dispatch = useDispatch()
    const lang = localStorage.getItem('lang')
    const {t} = useTranslation();

    useEffect(() => {
        dispatch(fetchSingleNewsData(props.match.params.id))
    }, [props.match.params.id])

    return (
        <Wrapper>
            <Container className="mt-5">
                {single_news.loading ?
                    <MainLoading />
                :
                    single_news.single_news.title ?
                    <div className='single_news'>
                        <Helmet>
                            <title>{single_news.single_news.title} - نمایشگاه مجازی</title>
                        </Helmet>
                        <HomeMainTitle> {single_news.single_news.title} </HomeMainTitle>
                        <div className='mt-3'>
                            <div className='single_news_image'>
                                {single_news.single_news.image ?
                                    <img src={default_image_url+single_news.single_news.image.path} alt="news"/>
                                :
                                    ''
                                }
                            </div>
                            <div className='col-lg-12 single_news_content'>{renderHTML(single_news.single_news.description)}</div>
                        </div>
                        <div className='single_news_footer'>
                            <span>{t("publish")} : 
                            {lang === "en" ?
                                single_news.single_news.created_at && single_news.single_news.created_at.substr(0, 10)
                            :
                                moment(single_news.single_news.created_at && single_news.single_news.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')} - {single_news.single_news.created_at.substr(11, 5)
                            }
                            </span>
                        </div>
                    </div>

                    :
                        <h6 className='text-center'> {t("No news has been recorded")} </h6>
                    }
            </Container>
        </Wrapper>
    )
}

export default SingleNews
